module.exports = __webpack_public_path__ + "img/anti-matter.0a338b50.png";